export default __webpack_public_path__ + "static/5contenido_pandanoticias-77a40a600887679fc7e0e84e864712ba.png";